import { Reducer } from 'redux';

import { IFetchHistory, ISetHistory, ISetRemote, THistory, TRemote } from '../actions';
import { History } from '../entities';

export type IHistoryState = History[];
export const defaultHistoryState = [];

export const historyReducer: Reducer<IHistoryState> =
  (state: IHistoryState = defaultHistoryState, action: ISetHistory | IFetchHistory | ISetRemote) => {
  switch (action.type) {
    case TRemote.SET_REMOTE:
      return defaultHistoryState;
    case THistory.SET_HISTORY:
      return action.payload;
  }
  return state;
};
